export enum SideNavSectionsEnum {
    PERSONAL_SETTINGS = 'Personal_Settings',
    PAYMENT_METHOD = 'Payment_Method',
    CREATOR_DETAILS = 'Creator_Details',
    PASSWORD = 'Password',
    API_KEY = 'API_Key'
  }
  